import type { QuestionStatus } from '@exam-management/graphql';

import { EDITABLE_QUESTION_LOCATION_STATUSES } from '../../constants';
import { LocationFormSection } from '../location-form-section';
import { LocationView } from '../location-view';

interface LocationSectionProps {
  readonly?: boolean;
  questionStatus: QuestionStatus;
}

export default function LocationSection(props: Readonly<LocationSectionProps>) {
  const { readonly: isReadonly = false, questionStatus } = props;

  const isEditable = EDITABLE_QUESTION_LOCATION_STATUSES.includes(questionStatus) && !isReadonly;

  if (isEditable) {
    return <LocationFormSection questionStatus={questionStatus} />;
  }

  return <LocationView />;
}
